import { Api } from "api";

export const getMeAdmin = async () => {
  const res = await Api.get("/auth/v1/meAdmin");
  return res.data;
};

export const getUsers = async (search: URLSearchParams, page?: number) => {
  let url = "/users/v1/admin/get";
  let params = search ? `?${search}` : "";
  const res = await Api.get(`${url}${params}`, {
    params: { page },
  });
  return res.data;
};

export const getUsersByIds = async (ids: string[]) => {
  const res = await Api.post("/users/v1/ids", { ids: ids });
  return res.data;
};

export const addUser = async (payload: any) => {
  const res = await Api.post("/users/v1/admin", payload);
  return res.data;
};

export const editUser = async (id: string, payload: any) => {
  const res = await Api.put(`/users/v1/admin/${id}`, payload);
  return res.data;
};

export const deleteUser = async (id: string) => {
  const res = await Api.delete(`/users/v1/admin/${id}`);
  return res.data;
};

export const changeUserStatus = async (
  id: string,
  status: "active" | "inactive"
) => {
  const res = await Api.put(
    `/users/v1/admin/status/${id}`,
    { status },
  );
  return res.data;
};

export const getExcel = async (search: URLSearchParams) => {
  let url = "/users/v1/admin/excel";
  let params = search ? `?${search}` : "";
  const res = await Api.get(`${url}${params}`, { responseType: 'blob', });
  return res.data;
};

export const getAdmins = async (searchParams: URLSearchParams) => {
  let url = "/users/v1/admin/allAdmins";
  let params = searchParams ? `?${searchParams}` : "";
  const res = await Api.get(`${url}${params}`);
  return res.data;
};

export const makeAdmin = async (payload: any) => {
  const res = await Api.post("/users/v1/admin/appointAdmin", payload);
  return res.data;
};

export const deleteAdmin = async (id: string) => {
  const res = await Api.delete(`/users/v1/admin/${id}/deleteAdmin`);
  return res.data;
};

export const getUserSessions = async (id: string) => {
  const res = await Api.get("/auth/v1/sessions", {
    params: { id },
  });
  return res.data;
};

export const deleteUserSessions = async (id: string, session_id: string) => {
  const res = await Api.delete("/auth/v1/sessions/delete", {
    params: { id, session_id},
  });
  return res.data;
};
